import classes from "./index.module.css";
import { Tooltip as MantineTooltip, TooltipProps as MantineTooltipProps } from "@mantine/core";

export interface TooltipProps extends MantineTooltipProps {
  autoWidth?: boolean;
}

const Tooltip = ({ children, autoWidth = false, ...rest }: TooltipProps) => {
  return (
    <MantineTooltip
      classNames={classes}
      radius={4}
      arrowOffset={25}
      arrowSize={8}
      withArrow
      closeDelay={100}
      events={{ hover: true, focus: false, touch: true }}
      position="top-start"
      data-width-auto={autoWidth}
      {...rest}>
      <span className={classes.childrenWrapper}>{children}</span>
    </MantineTooltip>
  );
};

export default Tooltip;
